<script setup>
/**
 * FormControlMRegistrantsRegistrantsSessionLogs
 * Composition-based wrapper around the Many-to-Many Relationship control.
 * Environment gatekeeper: Evaluates application flags on mount, hiding
 * auditing session logs from production layouts unless beta features are enabled.
 */
import {computed, onMounted} from 'vue'
import FormControlTypeRelationshipManyToMany from "@/common/form-control-type/FormControlTypeRelationshipManyToMany.vue"
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

const appStore = useAppStore()

const betaMode = computed(() => appStore.betaMode)

onMounted(() => {
    /**
     * Beta feature safety toggle: Drop visibility from the orchestration layer
     * if the application isn't explicitly flagged for experimental features.
     */
    if (!betaMode.value && props.field) {
        props.field.hidden = true
    }
})
</script>

<template>
    <FormControlTypeRelationshipManyToMany v-bind="$props" v-if="!field.hidden"/>
</template>

<style scoped>
/* Grid alignments and panel wrappers flow from the core relationship component */
</style>